<wbo-screen-layout-button (click)="selectItem()"
                          (dblclick)="selectSubMenu()"
                          [item]="item"
                          [image]="item.icon"
                          [selected]="(model.selectedItem$ | async) === item"
                          (navigated)="selectSubMenu()" [leftCommandsToggled]="isLeftCommandsToggled"
                          [rightCommandsToggled]="isRightCommandsToggled"
                          [showLeftCommands]="!(model.painting$ | async) && !(editService.$entityRestricted | async)"
                          [showNavigateTo]="showNavigateTo"
                          [showRightCommands]="!(model.painting$ | async) && !(editService.$entityRestricted | async)">
    <ng-template #leftCommands>
        <wbo-screen-layout-touch-item-commands (commandsToggled$)="leftCommandsToggled($event)" [item]="item" icon="plus">
        </wbo-screen-layout-touch-item-commands>
    </ng-template>
    <ng-template #rightCommands>
        <fui-commands icon="delete" (toggled$)="rightCommandsToggled($event)">
            <fui-command (clicked$)="clear()"
                         [title]="'wbo.screen-layout.edit.action.touchItem.clear'">
            </fui-command>
            <fui-command (clicked$)="delete()"
                         [title]="'wbo.screen-layout.edit.action.touchItem.remove'">
            </fui-command>
        </fui-commands>
    </ng-template>
</wbo-screen-layout-button>
